import { ProductQuickLink } from "./product-quick-link";

export class QuickLinkImage {
    product: ProductQuickLink;
    active: boolean;
    transition: string;
}
